import { z } from 'zod';

// captchaEnabled defaults to true so the field stays required until we
// actually hear back from the server that captcha is off — only once
// CaptchaBox reports { enabled: false } does Login.tsx pass false here,
// making captchaText optional (there's nothing to type when no captcha
// image ever loads).
export const createLoginSchema = (captchaEnabled: boolean = true) =>
  z.object({
    username: z
      .string()
      .min(1, 'username cannot be empty')
      .refine((value) => /[A-Za-z]/.test(value), {
        message: 'username must contain at least one alphabetic character',
      }),

    password: z.string().min(1, 'password cannot be empty').min(6, 'Minimum 6 characters required'),

    captchaText: captchaEnabled
      ? z.string().min(1, 'Validation cannot be empty')
      : z.string().optional(),

    rememberMe: z.boolean().optional(),
  });

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>;
